import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component
export default class ModalSearchUser extends Vue {
  @Prop({ default: false }) searchUser!: Boolean

  cellphone = null

  sendUser () {
    this.$emit('search-user', this.cellphone)
    this.cellphone = null
  }
}
